import AreaField from './area-field';
import CheckboxField from './checkbox-field';
import FieldWrapper from './field-wrapper';
import GroupField from './group-field';
import RadioField from './radio-field';
import SelectField from './select-field';
import TextField from './text-field';

export default {
  Wrapper: FieldWrapper,
  Text: TextField,
  Select: SelectField,
  Checkbox: CheckboxField,
  Area: AreaField,
  Group: GroupField,
  Radio: RadioField,
};
